__turbopack_context__.v({
  "card": "LLzNcG_card",
  "productImage": "LLzNcG_productImage",
  "productLink": "LLzNcG_productLink",
  "products": "LLzNcG_products",
  "productsTablet3": "LLzNcG_productsTablet3",
});
